(function () {
  'use strict';

  if (window.__nestCustomHeaderScroll20260723 === 'v4-primary-links-activate') return;
  window.__nestCustomHeaderScroll20260723 = 'v4-primary-links-activate';

  var keyboardClass = 'nest-keyboard-nav-active';
  var openClasses = ['opened', 'nest-keyboard-menu-open', 'keyboard-open', 'site-nav--active', 'is-open', 'open'];
  var activeItem = null;
  var focusableSelector = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
  var primaryAutoLinkPattern = /^(Mattresses|Bedding|Furniture|Home\s*&\s*Health|Why\s*Nest)$/i;

  function ready(callback) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', callback, { once: true });
    else callback();
  }

  function setAttr(element, name, value) {
    if (element && element.getAttribute(name) !== value) element.setAttribute(name, value);
  }

  function cleanText(element) {
    return (element && element.textContent || '').replace(/\s+/g, ' ').trim();
  }

  function styleElement(id) {
    var style = document.getElementById(id);
    if (!style) {
      style = document.createElement('style');
      style.id = id;
      (document.head || document.documentElement).appendChild(style);
    }
    return style;
  }

  function installHeaderKeyboardStyle() {
    styleElement('nest-desktop-menu-keyboard-parity-20260723-direct').textContent = [
      '@media (min-width:1021px){',
      '#shopify-section-header,#shopify-section-header header.site-header,#shopify-section-header header.site-header>nav{height:auto!important;max-height:none!important;overflow:visible!important}',
      '#collections-menu{height:80.5px!important;max-height:80.5px!important;overflow:visible!important}',
      'body.nest-keyboard-nav-active #collections-menu>li:focus-within>.megamenu,body.nest-keyboard-nav-active #collections-menu>li.opened>.megamenu,body.nest-keyboard-nav-active #collections-menu>li.nest-keyboard-menu-open>.megamenu,body.nest-keyboard-nav-active #collections-menu>li.keyboard-open>.megamenu,body.nest-keyboard-nav-active .sticky-header-content #collections-menu>li:focus-within>.megamenu,body.nest-keyboard-nav-active .sticky-header-content #collections-menu>li.opened>.megamenu,body.nest-keyboard-nav-active .sticky-header-content #collections-menu>li.nest-keyboard-menu-open>.megamenu,body.nest-keyboard-nav-active .sticky-header-content #collections-menu>li.keyboard-open>.megamenu{position:fixed!important;top:var(--nest-keyboard-menu-top,126px)!important;left:50%!important;right:auto!important;bottom:auto!important;width:var(--nest-keyboard-menu-width,min(1060px,calc(100vw - 80px)))!important;max-width:calc(100vw - 80px)!important;transform:translateX(-50%)!important;display:grid!important;grid-template-columns:minmax(0,1fr) minmax(320px,34%)!important;grid-auto-flow:column!important;align-items:start!important;column-gap:32px!important;opacity:1!important;visibility:visible!important;pointer-events:auto!important;z-index:1003!important}',
      'body.nest-keyboard-nav-active #collections-menu>li:focus-within>.megamenu>.megamenu-menu,body.nest-keyboard-nav-active #collections-menu>li.opened>.megamenu>.megamenu-menu,body.nest-keyboard-nav-active #collections-menu>li.nest-keyboard-menu-open>.megamenu>.megamenu-menu,body.nest-keyboard-nav-active #collections-menu>li.keyboard-open>.megamenu>.megamenu-menu{grid-column:1!important;grid-row:1!important;width:auto!important;max-width:none!important;min-width:0!important}',
      'body.nest-keyboard-nav-active #collections-menu>li:focus-within>.megamenu>.megamenu-right,body.nest-keyboard-nav-active #collections-menu>li.opened>.megamenu>.megamenu-right,body.nest-keyboard-nav-active #collections-menu>li.nest-keyboard-menu-open>.megamenu>.megamenu-right,body.nest-keyboard-nav-active #collections-menu>li.keyboard-open>.megamenu>.megamenu-right{grid-column:2!important;grid-row:1 / span 2!important;width:100%!important;min-width:0!important}',
      'body.nest-keyboard-nav-active #collections-menu>li:focus-within>.simple-dropdown,body.nest-keyboard-nav-active #collections-menu>li.opened>.simple-dropdown,body.nest-keyboard-nav-active #collections-menu>li.nest-keyboard-menu-open>.simple-dropdown,body.nest-keyboard-nav-active #collections-menu>li.keyboard-open>.simple-dropdown,body.nest-keyboard-nav-active #collections-menu>li:focus-within>.small,body.nest-keyboard-nav-active #collections-menu>li.opened>.small,body.nest-keyboard-nav-active #collections-menu>li.nest-keyboard-menu-open>.small,body.nest-keyboard-nav-active #collections-menu>li.keyboard-open>.small{display:block!important;opacity:1!important;visibility:visible!important;pointer-events:auto!important}',
      'body.nest-keyboard-nav-active #collections-menu>li:focus-within>a,body.nest-keyboard-nav-active #collections-menu>li.opened>a,body.nest-keyboard-nav-active #collections-menu>li.nest-keyboard-menu-open>a,body.nest-keyboard-nav-active #collections-menu>li.keyboard-open>a{background:#fff!important;color:#384F3B!important;position:relative!important;z-index:1004!important}',
      'body.nest-keyboard-nav-active #collections-menu>li:focus-within>.megamenu-closed-icon,body.nest-keyboard-nav-active #collections-menu>li.opened>.megamenu-closed-icon,body.nest-keyboard-nav-active #collections-menu>li.nest-keyboard-menu-open>.megamenu-closed-icon,body.nest-keyboard-nav-active #collections-menu>li.keyboard-open>.megamenu-closed-icon{display:none!important}',
      'body.nest-keyboard-nav-active #collections-menu>li:focus-within>.megamenu-opened-icon,body.nest-keyboard-nav-active #collections-menu>li.opened>.megamenu-opened-icon,body.nest-keyboard-nav-active #collections-menu>li.nest-keyboard-menu-open>.megamenu-opened-icon,body.nest-keyboard-nav-active #collections-menu>li.keyboard-open>.megamenu-opened-icon{display:inline-block!important}',
      'body.nest-keyboard-nav-active .simple-dropdown-container:focus-within>.simple-dropdown,body.nest-keyboard-nav-active .simple-dropdown-container.opened>.simple-dropdown,body.nest-keyboard-nav-active .simple-dropdown-container.nest-keyboard-menu-open>.simple-dropdown,body.nest-keyboard-nav-active .simple-dropdown-container.keyboard-open>.simple-dropdown,body.nest-keyboard-nav-active .simple-dropdown-container:focus-within>.small,body.nest-keyboard-nav-active .simple-dropdown-container.opened>.small,body.nest-keyboard-nav-active .simple-dropdown-container.nest-keyboard-menu-open>.small,body.nest-keyboard-nav-active .simple-dropdown-container.keyboard-open>.small{display:block!important;opacity:1!important;visibility:visible!important;pointer-events:auto!important}',
      'body.nest-keyboard-nav-active .simple-dropdown-container:focus-within>a,body.nest-keyboard-nav-active .simple-dropdown-container.opened>a,body.nest-keyboard-nav-active .simple-dropdown-container.nest-keyboard-menu-open>a,body.nest-keyboard-nav-active .simple-dropdown-container.keyboard-open>a{background:#fff!important;color:#384F3B!important;position:relative!important;z-index:1004!important}',
      'body.nest-keyboard-nav-active .simple-dropdown-container>.simple-dropdown,body.nest-keyboard-nav-active .simple-dropdown-container>.small{min-width:220px!important;z-index:1005!important}',
      '}'
    ].join('');

    var faqStyle = styleElement('nest-homepage-faq-keyboard-a11y-20260723');
    faqStyle.textContent = '.nest-ai-faq .nest-ai-faq__question:focus-visible{outline:3px solid #0067f4!important;outline-offset:3px!important}.nest-ai-faq .nest-ai-faq__question:focus:not(:focus-visible){outline:none}';
  }

  function setKeyboardMenuMetrics() {
    var root = document.documentElement;
    if (!root) return;
    var header = document.querySelector('#shopify-section-header, header.site-header');
    var rect = header && header.getBoundingClientRect ? header.getBoundingClientRect() : null;
    var width = window.innerWidth || root.clientWidth || 1200;
    root.style.setProperty('--nest-keyboard-menu-top', Math.ceil(rect ? rect.bottom : 0) + 'px');
    root.style.setProperty('--nest-keyboard-menu-width', Math.min(1060, Math.max(720, width - 80)) + 'px');
  }

  function isDesktop() {
    return window.matchMedia ? window.matchMedia('(min-width:1021px)').matches : window.innerWidth >= 1021;
  }

  function setKeyboardMode(enabled) {
    if (document.body) document.body.classList.toggle(keyboardClass, !!enabled);
    if (enabled) setKeyboardMenuMetrics();
  }

  function candidateScore(element) {
    var className = element.className || '';
    var text = (element.textContent || '').replace(/\s+/g, ' ').trim();
    var score = 0;
    if (/mega|menu|dropdown|simple|small|child|review|help|store|account|login/i.test(className)) score += 30;
    if (element.matches && element.matches('ul,ol,div')) score += 10;
    if (element.querySelectorAll) score += Math.min(element.querySelectorAll('a[href],button').length, 8) * 4;
    if (text.length > 20) score += 5;
    return score;
  }

  function topItem(element) {
    if (!element || !element.closest) return null;
    var inMenu = element.closest('.megamenu,.simple-dropdown,.simple-dropdown-menu,.site-nav__dropdown,.dropdown,.dropdown-menu,.small,.sub-menu,.submenu,[data-nest-utility-menu]');
    if (inMenu) return inMenu.closest('#collections-menu>li,#SiteNav>li,.simple-dropdown-container,li');
    return element.closest('#collections-menu>li,#SiteNav>li,.simple-dropdown-container,li');
  }

  function triggerFor(item) {
    if (!item) return null;
    var direct = null;
    try { direct = item.querySelector(':scope>a[href],:scope>button:not(.expand-subMenu),:scope>a.site-header__account[href]'); } catch (error) {}
    return direct || item.querySelector('a.reviews-menu,a.help-menu,a.stores-menu,a.site-header__account[href],a[href],button:not(.expand-subMenu)');
  }

  function findCandidateMenu(item, trigger) {
    if (!item) return null;
    var triggerText = cleanText(trigger);
    var candidates = Array.prototype.slice.call(item.children || []).concat(Array.prototype.slice.call(item.querySelectorAll('div,ul,ol'))).filter(function (element, index, list) {
      if (!element || element === trigger || list.indexOf(element) !== index) return false;
      if (trigger && (trigger.contains(element) || element.contains(trigger))) return false;
      if (element.matches && element.matches('a[href],button')) return false;
      if (!element.querySelector || !element.querySelector(focusableSelector)) return false;
      var text = cleanText(element);
      return text && text !== triggerText;
    });
    candidates.sort(function (a, b) { return candidateScore(b) - candidateScore(a); });
    if (candidates[0]) candidates[0].setAttribute('data-nest-utility-menu', 'true');
    return candidates[0] || null;
  }

  function menuFor(item, trigger) {
    if (!item) return null;
    var controlledId = trigger && trigger.getAttribute && trigger.getAttribute('aria-controls');
    var controlled = controlledId && document.getElementById(controlledId);
    if (controlled) return controlled;
    var direct = null;
    try { direct = item.querySelector(':scope>.megamenu,:scope>.simple-dropdown,:scope>.simple-dropdown-menu,:scope>.site-nav__dropdown,:scope>.dropdown,:scope>.dropdown-menu,:scope>.small,:scope>.sub-menu,:scope>.submenu,:scope>[data-nest-utility-menu]'); } catch (error) {}
    return direct || findCandidateMenu(item, trigger);
  }

  function controlsIn(menu) {
    return menu ? Array.prototype.slice.call(menu.querySelectorAll(focusableSelector)) : [];
  }

  function visibleControl(control) {
    if (!control) return false;
    var rect = control.getBoundingClientRect();
    var style = window.getComputedStyle(control);
    return rect.width > 0 && rect.height > 0 && style.display !== 'none' && style.visibility !== 'hidden' && control.getAttribute('tabindex') !== '-1';
  }

  function isPrimaryAutoLink(trigger) {
    return trigger && trigger.tagName && trigger.tagName.toLowerCase() === 'a' && trigger.getAttribute('href') && primaryAutoLinkPattern.test(cleanText(trigger));
  }

  function followTriggerLink(trigger) {
    var href = trigger && trigger.getAttribute && trigger.getAttribute('href');
    if (!href || href === '#') return false;
    window.location.href = trigger.href || href;
    return true;
  }

  function restoreTabStops(menu) {
    controlsIn(menu).forEach(function (control) {
      control.removeAttribute('aria-hidden');
      if (control.getAttribute('data-nest-menu-tabindex') !== null) {
        var previous = control.getAttribute('data-nest-menu-tabindex');
        control.removeAttribute('data-nest-menu-tabindex');
        if (previous === '') control.removeAttribute('tabindex');
        else control.setAttribute('tabindex', previous);
      }
      if (control.getAttribute('tabindex') === '-1') control.removeAttribute('tabindex');
    });
  }

  function openItem(item) {
    if (!item || !isDesktop()) return false;
    var trigger = triggerFor(item);
    var menu = menuFor(item, trigger);
    if (!menu) return false;
    if (activeItem && activeItem !== item) closeItem(activeItem);
    activeItem = item;
    setKeyboardMode(true);
    openClasses.forEach(function (className) { item.classList.add(className); });
    menu.classList.add('opened');
    menu.setAttribute('aria-hidden', 'false');
    menu.style.opacity = menu.classList.contains('megamenu') ? '' : '1';
    menu.style.visibility = menu.classList.contains('megamenu') ? '' : 'visible';
    menu.style.pointerEvents = menu.classList.contains('megamenu') ? '' : 'auto';
    menu.style.display = menu.classList.contains('megamenu') ? '' : 'block';
    restoreTabStops(menu);
    if (trigger) {
      trigger.setAttribute('aria-haspopup', 'true');
      trigger.setAttribute('aria-expanded', 'true');
      if (!trigger.hasAttribute('tabindex')) trigger.setAttribute('tabindex', '0');
      if (trigger.tagName && trigger.tagName.toLowerCase() === 'a') trigger.removeAttribute('role');
    }
    return true;
  }

  function closeItem(item) {
    if (!item) return;
    var trigger = triggerFor(item);
    var menu = menuFor(item, trigger);
    openClasses.forEach(function (className) { item.classList.remove(className); });
    if (menu) {
      menu.classList.remove('opened');
      menu.setAttribute('aria-hidden', 'true');
      menu.style.display = '';
      menu.style.opacity = '';
      menu.style.visibility = '';
      menu.style.pointerEvents = '';
    }
    if (trigger && menu) trigger.setAttribute('aria-expanded', 'false');
    if (activeItem === item) activeItem = null;
  }

  function focusFirstMenuControl(item) {
    var trigger = triggerFor(item);
    var menu = menuFor(item, trigger);
    if (!menu) return false;
    openItem(item);
    window.setTimeout(function () {
      var first = controlsIn(menu).filter(visibleControl)[0] || controlsIn(menu)[0];
      if (first && first.focus) first.focus();
    }, 60);
    return true;
  }

  function installHeaderKeyboardBridge() {
    if (window.__nestHeaderKeyboardBridge20260723Direct) return;
    window.__nestHeaderKeyboardBridge20260723Direct = true;

    document.addEventListener('keydown', function (event) {
      var key = event.key;
      if (key === 'Tab' || key === 'ArrowDown' || key === 'ArrowUp' || key === 'ArrowLeft' || key === 'ArrowRight' || key === 'Enter' || key === ' ' || key === 'Spacebar' || key === 'Escape') setKeyboardMode(true);
      if (!isDesktop()) return;
      if (key === 'Escape' && activeItem) {
        var trigger = triggerFor(activeItem);
        closeItem(activeItem);
        if (trigger && trigger.focus) trigger.focus();
        event.preventDefault();
        return;
      }
      if (key !== 'Enter' && key !== ' ' && key !== 'Spacebar' && key !== 'ArrowDown') return;
      var item = topItem(document.activeElement);
      if (!item) return;
      var trigger = triggerFor(item);
      if (document.activeElement !== trigger && !(trigger && trigger.contains(document.activeElement))) return;
      if (!menuFor(item, trigger)) return;
      if ((key === 'Enter' || key === ' ' || key === 'Spacebar') && isPrimaryAutoLink(trigger)) {
        event.preventDefault();
        event.stopPropagation();
        followTriggerLink(trigger);
        return;
      }
      event.preventDefault();
      event.stopPropagation();
      focusFirstMenuControl(item);
    }, true);

    document.addEventListener('focusin', function (event) {
      if (!isDesktop()) return;
      var item = topItem(event.target);
      if (item && document.body && document.body.classList.contains(keyboardClass)) openItem(item);
    }, true);

    document.addEventListener('focusout', function () {
      window.setTimeout(function () {
        if (activeItem && !activeItem.contains(document.activeElement)) closeItem(activeItem);
      }, 90);
    }, true);

    window.addEventListener('resize', function () {
      if (document.body && document.body.classList.contains(keyboardClass)) setKeyboardMenuMetrics();
    }, { passive: true });

    window.addEventListener('scroll', function () {
      if (activeItem && document.body && document.body.classList.contains(keyboardClass)) setKeyboardMenuMetrics();
    }, { passive: true });

    ['pointerdown', 'mousedown', 'touchstart'].forEach(function (type) {
      document.addEventListener(type, function () {
        setKeyboardMode(false);
        if (activeItem) closeItem(activeItem);
      }, true);
    });
  }

  function installFaqStateSync() {
    var summaries = Array.prototype.slice.call(document.querySelectorAll('.nest-ai-faq__item > .nest-ai-faq__question'));
    summaries.forEach(function (summary) {
      var details = summary.closest && summary.closest('details');
      if (!details) return;
      setAttr(summary, 'aria-expanded', details.open ? 'true' : 'false');
      if (summary.getAttribute('data-nest-faq-sync-ready') === 'true') return;
      setAttr(summary, 'data-nest-faq-sync-ready', 'true');
      details.addEventListener('toggle', function () {
        setAttr(summary, 'aria-expanded', details.open ? 'true' : 'false');
      });
    });
  }

  function installAll() {
    installHeaderKeyboardStyle();
    setKeyboardMenuMetrics();
    installHeaderKeyboardBridge();
    installFaqStateSync();
  }

  ready(function () {
    installAll();
    [250, 800, 1600, 3200].forEach(function (delay) { window.setTimeout(installAll, delay); });
  });
})();
